
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorStep as ObiElectricGeneratorStepElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-step.js';
 
 
 

 
 export const ObiElectricGeneratorStep = createComponent({
   react: React,
   tagName: 'obi-electric-generator-step',
   elementClass: ObiElectricGeneratorStepElement,
   events: {
     
   }
  });
 
 